module.exports = __webpack_public_path__ + "media/lifesum-intro-ru-a27859a1.mp4";